exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".AppVersion[data-v-598c5b1c]{position:absolute;right:10px;top:5px;font-size:12px}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Common/AppVersion/style.sass"],"names":[],"mappings":"AACA,6BACE,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,cAAgB,CACjB","file":"style.sass","sourcesContent":["\n.AppVersion[data-v-598c5b1c] {\n  position: absolute;\n  right: 10px;\n  top: 5px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-598c5b1c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/styles/defs/_colors.sass","./src/styles/defs/_fonts.sass","./src/styles/mixins/_mixins.sass"]}!./src/components/Common/AppVersion/style.sass
// module id = 1231
// module chunks = 3